import { useQuery } from '@tanstack/react-query';
import Price from '../models/Price';
import Option from '../models/Option';

export default function useOptions(packageId, schoolId) {
  return useQuery(['options', packageId, schoolId], () => (
    Option
      .includes(['image_types', 'prices'])
      .merge({ prices: Price.where({ for_school: schoolId }) })
      .where({ packageId })
      .order('abbreviation')
      .all()
      .then((res) => res.data)
  ), { placeholderData: [], enabled: (!!packageId && !!schoolId) });
}
